/*
 * Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

import { logInfo, type LogTarget } from '@amazon/vinyl-util'
import { type MutableValue } from '@amazon/vinyl-observable'
import type { AuthStatus } from '@amzn/bf-playback'

/**
 * Change-guarded auth status transition shared by every controller: no-op (and
 * no log) when the value is unchanged, otherwise log the `from -> to` at INFO
 * and commit the new value. Centralizing this keeps the transition log identical
 * everywhere and gives the change-guard to controllers that used to log inline.
 */
export function logStatusTransition(
    target: LogTarget,
    status$: MutableValue<AuthStatus>,
    next: AuthStatus
): void {
    if (status$.value === next) return
    logInfo(target, `status ${status$.value} -> ${next}`)
    status$.value = next
}
